var FileDrawer = /*#__PURE__*/function (FileDrawer) {
  FileDrawer["Client"] = "Client";
  FileDrawer["My"] = "My";
  FileDrawer["Firm"] = "Firm";
  FileDrawer["All"] = "All";
  return FileDrawer;
}(FileDrawer || {});
export default FileDrawer;
export function isClientDrawer(drawer) {
  return drawer === FileDrawer.Client;
}
